import styled from '@emotion/styled';
import { DailyActivityWrapper } from '@seedlang/hoc';
import { AppUI } from '@seedlang/state';
import DailyActivityCalendar from 'components/daily_activity/daily_activity_calendar';
import DailyActivityFooter from 'components/daily_activity/daily_activity_footer';
import DailyActivityHeader from 'components/daily_activity/daily_activity_header';
import DailyActivityInfo from 'components/daily_activity/daily_activity_info';
import DailyActivityList from 'components/daily_activity/daily_activity_list';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

const Wrapper = styled.div`
  width: 210px;
`;

@observer
class DailyActivity extends React.Component {
  @observable showInfo = false;

  render() {
    return (
      <Wrapper>
        {
          !this.showInfo &&
            <DailyActivityHeader
              {...this.props}
            />
        }
        {
          AppUI.user.xpView === 'calendar' && !this.showInfo &&
            <DailyActivityCalendar
              {...this.props}
              showFlags={this.props.user.targetLanguagesWithXpCount > 1}
            />
        }
        {
          AppUI.user.xpView !== 'calendar' && !this.showInfo &&
            <DailyActivityList
              {...this.props}
              showFlags={this.props.user.targetLanguagesWithXpCount > 1}
            />
        }
        {
          this.showInfo &&
            <DailyActivityInfo
              hideInfo={() => this.showInfo = false}
            />
        }
        <DailyActivityFooter
          showInfo={this.showInfo}
          toggleInfo={() => this.showInfo = !this.showInfo}
          {...this.props}
        />
      </Wrapper>
    );
  }
}

export default DailyActivityWrapper(DailyActivity);
